import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDot = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 3 3",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:#657468;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "icon_dot" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 1.5,
			cy: 1.5,
			r: 1.5
		})
	]
});
export default SvgDot;
